import React, {
  useEffect,
  useState,
} from "react";

import axios from "../../api/axiosinstance";

import {
  Link,
} from "react-router-dom";

function TesterProjects() {

  const [projects, setProjects] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  /* =========================
     LOAD ASSIGNED PROJECTS
  ========================= */

  const loadProjects =
    async () => {

      try {

        setLoading(true);

        const res =
          await axios.get(
            "/projects/assigned-testing"
          );

        if (res.code === 200) {

          setProjects(
            res.data || []
          );

        }

      } catch (err) {

        console.log(err);

      } finally {

        setLoading(false);

      }

    };

  /* =========================
     LOAD ON PAGE OPEN
  ========================= */

  useEffect(() => {

    loadProjects();

  }, []);

  /* =========================
     STATUS BADGE
  ========================= */

  const getStatusBadge =
    (status) => {

      switch (status) {

        case "assigned":

          return "bg-primary";

        case "in_testing":

          return "bg-info";

        case "bug_found":

          return "bg-danger";

        case "retesting":

          return "bg-warning text-dark";

        case "approved":

          return "bg-success";

        default:

          return "bg-secondary";

      }

    };

  /* =========================
     PRIORITY BADGE
  ========================= */

  const getPriorityBadge =
    (priority) => {

      switch (priority) {

        case "high":

          return "bg-danger";

        case "medium":

          return "bg-warning text-dark";

        case "low":

          return "bg-success";

        default:

          return "bg-secondary";

      }

    };

  /* =========================
     FORMAT STATUS
  ========================= */

  const formatStatus =
    (status) => {

      if (!status) {
        return "Not Assigned";
      }

      return status
        .replace(
          /_/g,
          " "
        )
        .replace(
          /\b\w/g,
          (char) =>
            char.toUpperCase()
        );

    };

  return (

    <div className="content">

      {/* =========================
         PAGE HEADER
      ========================= */}

      <div
        className="
          d-flex
          justify-content-between
          align-items-center
          mb-4
        "
      >

        <div>

          <h3 className="fw-bold mb-1">

            🧪 My Testing Projects

          </h3>

          <p className="text-muted mb-0">

            Projects assigned to you for testing

          </p>

        </div>

        <span
          className="
            badge
            bg-primary
            fs-6
            px-3
            py-2
          "
        >

          {projects.length} Projects

        </span>

      </div>


      {/* =========================
         PROJECT LIST
      ========================= */}

      <div
        className="
          card
          border-0
          shadow-sm
        "
      >

        <div className="card-body">

          {loading ? (

            <div className="text-center py-5">

              Loading Projects...

            </div>

          ) : projects.length === 0 ? (

            <div
              className="
                text-center
                py-5
                text-muted
              "
            >

              <h5>

                No Testing Projects Found

              </h5>

              <p className="mb-0">

                You don't have any projects
                assigned for testing.

              </p>

            </div>

          ) : (

            <div className="table-responsive">

              <table
                className="
                  table
                  table-hover
                  align-middle
                "
              >

                <thead
                  className="
                    table-light
                  "
                >

                  <tr>

                    <th>
                      #
                    </th>

                    <th>
                      Project
                    </th>

                    <th>
                      Client
                    </th>

                    <th>
                      Developer
                    </th>

                    <th>
                      Priority
                    </th>

                    <th>
                      Testing Status
                    </th>

                    <th>
                      Deadline
                    </th>

                    <th>
                      Action
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {projects.map(
                    (
                      project,
                      index
                    ) => (

                      <tr
                        key={
                          project._id
                        }
                      >

                        {/* NUMBER */}

                        <td>

                          {
                            index + 1
                          }

                        </td>


                        {/* PROJECT */}

                        <td>

                          <strong>

                            {
                              project.projectName
                            }

                          </strong>

                        </td>


                        {/* CLIENT */}

                        <td>

                          {
                            project
                              ?.leadId
                              ?.name
                              || "N/A"
                          }

                        </td>


                        {/* DEVELOPER */}

                        <td>

                          {
                            project
                              ?.assignedDeveloper
                              ?.name
                              || "N/A"
                          }

                        </td>


                        {/* PRIORITY */}

                        <td>

                          <span
                            className={
                              `badge ${getPriorityBadge(
                                project.priority
                              )}`
                            }
                          >

                            {
                              formatStatus(
                                project.priority
                              )
                            }

                          </span>

                        </td>


                        {/* TESTING STATUS */}

                        <td>

                          <span
                            className={
                              `badge ${getStatusBadge(
                                project.testingStatus
                              )}`
                            }
                          >

                            {
                              formatStatus(
                                project.testingStatus
                              )
                            }

                          </span>

                        </td>


                        {/* DEADLINE */}

                        <td>

                          {
                            project.deadline
                              ? new Date(
                                  project.deadline
                                )
                                  .toLocaleDateString()
                              : "-"
                          }

                        </td>


                        {/* ACTION */}

                        <td>

                          <Link
                            to={
                              `/tester-project/${project._id}`
                            }
                            className="
                              btn
                              btn-sm
                              btn-primary
                            "
                          >

                            View Project

                          </Link>

                        </td>

                      </tr>

                    )
                  )}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>

    </div>

  );

}

export default TesterProjects;